import config from 'config';

import { useDomain } from '../../techstyle-shared/redux-core';

const builderLocales = config.get('public.intl.builderLocales');
/**
 * Retrieves the user's locale based on the TLD (Top-Level Domain) of the website.
 * This is useful for determining the appropriate language and region settings
 * for the user based on their geographical location.
 *
 * The specific use case for this being necessary is when dealing with SXF being
 * different because of UK vs EU.
 *
 * @returns The locale based on the TLD
 */
export default function useTldLocale() {
  const { tld } = useDomain();
  const userAttributesLocale = builderLocales[tld];
  return userAttributesLocale;
}
